import { render, staticRenderFns } from "./AssetReferenceList.vue?vue&type=template&id=521de460"
import script from "./AssetReferenceList.vue?vue&type=script&lang=js"
export * from "./AssetReferenceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports